import { hexFromArgb, TonalPalette } from '@material/material-color-utilities';
export const generateTonalColorPalette = (hue, chroma, tones) => tones.map((tone) => hexFromArgb(TonalPalette.fromHueAndChroma(hue, chroma).tone(tone)));
